import { useMemo } from 'react';

import { useRouter } from 'next/router';

import useGender from '~/shared/utils/useGender';
import { useCustomerDetails } from '~/techstyle-shared/react-accounts';
import { useMarketingDisposition } from '~/techstyle-shared/react-marketing';

import { ExperienceIds } from '../constants/experienceIds';

// Utility function to get the Postreg tab id the new user should land on
export default function useBuilderPostRegTabId(tabs) {
  // To get the Postreg tab id, we need to know the quiz offer of our new postreg customer
  const { query } = useRouter();
  const [quizOffer] = useCustomerDetails(['quiz_offer']);
  const { isMale } = useGender();
  const disposition = useMarketingDisposition();
  const experienceId = disposition?.experience;

  const postRegTabIdInfo = useMemo(() => {
    const findSelectedTabId = (offerId) =>
      tabs?.find((tab) => tab?.tabId === offerId);

    let selectedTabId = tabs?.at(0)?.tabId || '';
    let tabIndex = 0;
    const queryTabId = findSelectedTabId(query.tab);
    const quizOfferTabId = findSelectedTabId(quizOffer);
    const genderTabId = isMale
      ? findSelectedTabId('offer2')
      : findSelectedTabId('offer1');

    // If we dont have any tabs, dont process anything
    if (tabs?.length === 0) {
      return { selectedTabId: undefined, tabIndex: 0 };
    }

    // Order: prioritize the url parameter, then the quiz answer, then fallback to the first tab
    if (query.tab && queryTabId) {
      tabIndex = tabs.indexOf(queryTabId);
      selectedTabId = queryTabId;
    } else if (quizOffer && quizOfferTabId) {
      // If that fails, see if we can get the selectedTab using the quizOffer
      selectedTabId = quizOfferTabId;
      tabIndex = tabs.indexOf(quizOfferTabId);
    } else if (experienceId === ExperienceIds.SCRUBS) {
      // If that fails, for dealing with scrubs, there is a different default tab for men vs women
      selectedTabId = genderTabId;
      tabIndex = tabs.indexOf(genderTabId);
    }

    // If that fails, pass back index 0
    return { selectedTabId, tabIndex };
  }, [experienceId, isMale, query.tab, quizOffer, tabs]);
  return postRegTabIdInfo;
}
